export default "<div class=\"footer\">\r\n    <p> © Copyright Dream Innovator 2025</p>\r\n</div>"